/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function () {

				$(".js-cart-delete-btn").on("click", function(){

					var data = {
						"id":			$(this).data("id"),
						"post_type":	$(this).data("post-type"),
						"extra_params": $(this).data("extra-params")
					}

					var parentRow = $(this).parents(".btn-col").parent();

					toggleCartLoadingIcon(parentRow);

					$.post(
						ajaxVars.store_ajaxurl,
						{
							"action": "delete_from_cart",
							"data": $.param(data)
						},
						function(data) {

							if(data.status){

								if(data.do_refresh){
									window.location.reload(true);
								}

								var parentTable = parentRow.parents("table");

								if(parentRow.is("tr[class=line-item-row]") && parentRow.next().hasClass("sub-item-header-row")){
									parentRow.nextUntil("tr:not(.sub-item-row)").remove();
								}

								parentRow.remove();

								parentTable.trigger("rm.cart.updated");

							}else{

								toggleCartLoadingIcon(parentRow);

							}

						}

					);

				});

				$(".js-cart-update-quantity").on("change", function(){

					var quantitySelect = $(this);

					var data = {
						"id":			$(this).data("id"),
						"post_type":	$(this).data("post-type"),
						"quantity":		$(this).val()
					};

					var parentRow = quantitySelect.parents(".quantity-col").parent();

					$(this).prop("disabled", true);

					toggleCartLoadingIcon(parentRow);

					if(typeof $(this).data("extra-params") !== undefined && $(this).data("extra-params") !== ""){
						data.extra_params = $(this).data("extra-params");
					}

					$.post(
						ajaxVars.store_ajaxurl,
						{
							"action": "update_cart",
							"data": $.param(data)
						},
						function(data) {

							if(data.status){

								updateDiscountAmount(parentRow, data.discount_amount);

								var updatedItemIds = [data.updated_item_id];

								if(!parentRow.is(".sub-item-row")) {

									parentRow.siblings(".sub-item-row:not(.sub-item-header-row)").each(function () {

										if(parseInt($(".js-cart-update-quantity", this).val()) > parseInt(quantitySelect.val())){

											$(".js-cart-update-quantity", this).val(quantitySelect.val());

											updatedItemIds.push($(this).data("item-id"));

										}

										if(parseInt($(".js-cart-update-quantity option:last-child", this).val()) < parseInt(quantitySelect.val())){

											// Add
											var i = parseInt($(".js-cart-update-quantity option:last-child", this).val()) + 1;
											var maxQuantity = parseInt(quantitySelect.val());

											for(i; i <= maxQuantity; i++){

												$(".js-cart-update-quantity", this).append(
													$("<option>")
														.attr("value", i)
														.text(i)
												);

											}

										}else if(parseInt($(".js-cart-update-quantity option:last-child", this).val()) > parseInt(quantitySelect.val())){

											// Remove
											$(".js-cart-update-quantity option", this).slice(parseInt(quantitySelect.val()) + 1).remove();

										}

									});

								}

								parentRow.trigger("rm.cart.updated", [updatedItemIds]);

							}else{



							}

							quantitySelect.prop("disabled", false);
							toggleCartLoadingIcon(parentRow);

						}

					);

				});

				$(".pk-code-form").on("submit", function(){

					var pkCodeForm = $(this);

					setPKCodeFormDisabled($(this), true);

					var submitBtn = pkCodeForm.find(".input-group .input-group-btn");

					var submitBtnText = submitBtn.find(".btn").text();

					submitBtn
						.css("width", submitBtn.width())
						.find(".btn")
							.css("width", "100%")
							.html(
								$("<span>").addClass("fa fa-pulse fa-spinner")
							);

					pkCodeForm.find("span.help-block").remove();

					$.post(
						ajaxVars.store_ajaxurl,
						{
							"action": "apply_pk_code",
							"data": $(this).serialize()
						},
						function(data) {

							if(data.status){

								if(Number(data.discount_amount) > 0){

									var parentRow = pkCodeForm.parents(".key-code-col").parent();

									updateDiscountAmount(parentRow, data.discount_amount);

									parentRow.trigger("rm.cart.updated", [data.updated_item_id]);

								}

							}else{

								pkCodeForm.addClass("has-error");

								pkCodeForm.append(
									$("<span>").addClass("help-block text-danger").text(data.message)
								);

							}

							setPKCodeFormDisabled(pkCodeForm, false);

							submitBtn
								.css("width", "auto")
								.find(".btn")
									.text(submitBtnText);

						}

					);

					return false;

				});

				$("#cart").on("rm.cart.updated", function(evt, updated_item_ids){

					var cartSubtotal = 0;
					var cartDiscountTotal = 0;

					var cartCurrencySymbol = $(".js-cart-currency-symbol", this).val();

					if(typeof updated_item_ids !== "object"){
						updated_item_ids = [updated_item_ids];
					}

					if($("tr.line-item-row", this).length < 1){

						var emptyCartElement =
							$("<tr>")
								.addClass("line-item-row")
								.append(
									$("<td>")
										.addClass("item-col")
										.prop("colspan", 4)
										.append(
											$("h5").text("Your cart is currently empty")
										)
								)
								.append(
									$("<td>").addClass("btn-col")
								);

						if($("tbody tr:first-child", this).hasClass("ecom-order-table-header-row")){

							$(".ecom-order-table-header-row", this).after(emptyCartElement);

						}else{

							$("tbody", this).prepend(emptyCartElement);

						}

						$("#checkout-start-form").find(".cart-terms-privacy-check").html("");

						$("#checkout-start-form").find(".cart-checkout-btn button").prop("disabled", true);

					}else{

						$("tr.line-item-row", this).each(function(){

							var quantity = ($(".js-cart-update-quantity", this).length > 0) ? parseInt($(".js-cart-update-quantity", this).val()) : 1;

							// More accurate way of rounding a float
							// Math.pow(10, 2): 2 == the number of decimal places to round to
							var unitPrice = Math.round(parseFloat($(".js-line-item-unit-price", this).val()) * Math.pow(10, 2)) / Math.pow(10, 2);
							var lineItemSubTotal = unitPrice * quantity;

							var unitDiscount = 0.0;

							if($(".js-line-item-discount-amount", this).length > 0){
								unitDiscount = Math.round(parseFloat($(".js-line-item-discount-amount", this).val()) * Math.pow(10, 2)) / Math.pow(10, 2);
							}

							var lineItemTotalDiscount = unitDiscount * quantity;

							cartSubtotal += lineItemSubTotal;
							cartDiscountTotal += lineItemTotalDiscount;

							if(updated_item_ids.indexOf($(this).data("item-id")) >= 0){

								var hasSlashedPrice = ($(".price-col", this).has("h4.slashed-price").length > 0) ? true : false;

								var lineItemTotal = lineItemSubTotal - lineItemTotalDiscount;

								var subTotalElement;

								// Select element that contains the subtotal text
								if(hasSlashedPrice){

									subTotalElement = $(".price-col .slashed-price", this);

								}else{

									subTotalElement = $(".price-col .js-line-item-total", this);

								}

								// Update line item subtotal
								// Regular expression replaces any digit that is followed by one or more
								// groups of three digits and a decimal point with that digit plus a comma.
								// Essentially formats the number by grouped thousands
								subTotalElement.text(cartCurrencySymbol + lineItemSubTotal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));

								if(lineItemTotalDiscount > 0){

									// If the slashed prices isn't being displayed, display it
									if(!hasSlashedPrice) {

										// Convert the current sub total price to the slashed price
										$(".price-col .js-line-item-total", this)
											.removeClass("js-line-item-total")
											.addClass("slashed-price");

										// Add a new line item total element
										$(".price-col .slashed-price", this)
											.after(
												$("<h4>").addClass("js-line-item-total")
											);

									}

									// Update the line item total
									$(".price-col .js-line-item-total", this).text(cartCurrencySymbol + lineItemTotal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));

								}else if(hasSlashedPrice){

									$(".price-col .js-line-item-total", this).remove();

									$(".price-col .slashed-price", this)
										.removeClass("slashed-price")
										.addClass("js-line-item-total");

								}

							}

						});

						// If a tr with the table header class is the first child of a body, we know that all
						// the conference cart items have been removed, so we'll remove the conference items header
						if($("tbody tr:first-child", this).hasClass("ecom-order-table-header-row")){

							$("thead > tr", this).hide();

						}

						// If the row after the second table header row is not a line item, then
						// all the items under that have been removed, so we'll that header
						$(".ecom-order-table-header-row", this).each(function(){

							if(!$(this).next().hasClass("line-item-row")){
								$(this).hide();
							}

						});

						$(".sub-item-header-row", this).each(function(){

							if(!$(this).next().hasClass("sub-item-row")){
								$(this).hide();
							}

						});

					}

					var cartTotal = cartSubtotal - cartDiscountTotal;

					$("#order-subtotal-display").text(cartCurrencySymbol + cartSubtotal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));
					$("#order-discount-total-display").text(cartCurrencySymbol + cartDiscountTotal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));

					$("#order-total-display").text(cartCurrencySymbol + cartTotal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));

				});

				$(".js-tooltip-toggle").tooltip({
					container:	"body",
					html:		true
				});

				$("#cart-how-did-you-hear-select").on("change", function(){

					$("#checkout-start-form").find('input[name="data[how_did_you_hear]"]').val($(this).val());

				});

				$('.account-signin-toggle .radio input[data-toggle="tab"]').on("shown.bs.tab", function(evt){

					// For the show.bs.tab event, the currently active panel is the one that's about to be hidden
					$($(this).data("target")).parent().find(".tab-pane:not(.active)")
						.find(".form-group :input").prop("disabled", true);

					// For the show.bs.tab event, the clicked tag's target is the panel that's about to be shown
					$($(this).data("target")).find(".form-group :input").prop("disabled", false);


				});

				$(".account-signin-fields .checkout-details-fieldset.tab-pane:not(.active.in)")
					.find(".form-group :input").prop("disabled", true);

				$(".event-attendee-info-fields")
					.on("blur", ".attendee-details-fieldset .form-group input.form-control", manageAutofillProfiles)
					.on("change", ".attendee-details-fieldset .form-group select.form-control:enabled, .attendee-details-fieldset .radio-group input", manageAutofillProfiles);

				$(".js-select-autofill-profile").on("change", function(){

					if($(this).val() !== "" && (typeof autofillProfiles !== "undefined")){

						var profileHash = $(this).val();

						if(typeof autofillProfiles[profileHash] !== "undefined"){

							var profile = autofillProfiles[profileHash];

							var form = $($(this).data("target"));

							autofillForm(form, profile);

						}

					}

				});

				$(".event-attendee-info-fields .js-select-autofill-profile").on("change", function(){

					var radioValue = ($(this).val() === "") ? "new" : "profile";

					$(this).parents(".attendee-profile-select-content-box")
						.find(':radio[name^="profile_select_toggle"]')
							.val([radioValue]);

				});

				$("select[multiple]").select2();

				if($(".payment-form-embed-wrap").length > 0){

					if($(".payment-form-embed-wrap").is(":visible")){

						$(".checkout-next-prev-btns-row").toggleClass("payment-iframe-offset");

					}

				}

				$(':radio[name$="\\[billing_method\\]"]').on("click", function(){

					$(".payment-form-error-wrap, .payment-form-embed-wrap").toggle();

					$(".checkout-next-prev-btns-row").toggleClass("payment-iframe-offset");

				});

			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);


	var setPKCodeFormDisabled = function(form, disabledVal){

		form.find(".btn").prop("disabled", disabledVal);
		form.find(".form-control").prop("readonly", disabledVal);

	};

	var updateDiscountAmount = function(lineItemRow, discountAmount){

		var unitDiscountAmount = parseFloat(discountAmount);

		lineItemRow.find(".js-line-item-discount-amount").val(unitDiscountAmount);

	};

	var toggleCartLoadingIcon = function(lineItemRow){

		lineItemRow.find(".btn-col .js-cart-delete-btn").toggle();
		lineItemRow.find(".btn-col .js-loading-icon").toggle();

	};

	var autofillForm = function(form, values, namePrefix){

		for(var fieldName in values){

			if(typeof values[fieldName] === "object"){

				autofillForm(form, values[fieldName], '\\[' + fieldName + '\\]');

			}else if(values[fieldName] !== ""){

				var fieldNameSelector = ':input[name$="';

				if((typeof namePrefix !== "undefined") && namePrefix !== ""){
					fieldNameSelector += namePrefix;
				}

				fieldNameSelector += '\\[' + fieldName + '\\]"]';

				var field = form.find(fieldNameSelector);

				if(field.length > 0){

					if(field.attr("type") === "radio" || field.attr("type") === "checkbox"){

						field.val([values[fieldName]]);

					}else{

						field.val(values[fieldName]);

					}

					if(field.is("select")){
						field.change();
					}

				}

			}

		}

	};

	var manageAutofillProfiles = function(evt){

		var profileCompleted = true;

		$(".attendee-details-fieldset", evt.delegateTarget).find(".form-group .form-control:enabled, .radio-group input").each(function(){

			if($(this).prop("required") && $(this).val() === ""){
				profileCompleted = false;
			}

		});

		if(!profileCompleted){
			return;
		}

		var autofillProfile = {};

		$(".attendee-details-fieldset", evt.delegateTarget).find(".form-group .form-control:enabled, .radio-group input").each(function(){

			if($(this).is(":radio") && !$(this).prop("checked")){
				return;
			}

			var fieldName = $(this).attr("name").replace(/^data\[(addon_)?attendees\]\[\d\]/, "");

			var nameMatchedParts = fieldName.match(/\[[^\[\]]*\]/g);

			if(nameMatchedParts.length > 1){

				var profileParentProperty = nameMatchedParts[0].substring(1, (nameMatchedParts[0].length - 1));

				if(!autofillProfile.hasOwnProperty(profileParentProperty)){
					autofillProfile[profileParentProperty] = {};
				}

				var profileProperty = nameMatchedParts[1].substring(1, (nameMatchedParts[1].length - 1));

				autofillProfile[profileParentProperty][profileProperty] = $(this).val();

			}else{

				var profileProperty = nameMatchedParts[0].substring(1, (nameMatchedParts[0].length - 1));

				autofillProfile[profileProperty] = $(this).val();

			}

		});

		var identityUpdated = false;

		// If identity field has been updated, change value of existing option in select and delete old autofill profile
		if(evt.delegateTarget.hasAttribute("data-profile-identity") && $(evt.delegateTarget).data("profile-identity") !== autofillProfile.identity){

			identityUpdated = true;

			delete autofillProfiles[$(evt.delegateTarget).data("profile-identity")];

		}

		autofillProfiles[autofillProfile.identity] = autofillProfile;

		$(".js-select-autofill-profile").each(function(){

			if(identityUpdated){
				$('option[value="' + $(evt.delegateTarget).data("profile-identity") + '"]', this).remove();
			}

			if($(this).children('option[value="' + autofillProfile.identity + '"]').length === 0){

				$(this).append(
					$("<option>")
						.attr("value", autofillProfile.identity)
						.text(autofillProfile.first_name + " " + autofillProfile.last_name)
				);

			}

		});

		$(evt.delegateTarget).attr("data-profile-identity", autofillProfile.identity);

console.log(autofillProfile);
		console.log(autofillProfiles);
	};

})(jQuery); // Fully reference jQuery after this point.
